module.exports = __webpack_public_path__ + "media/images/emoticons/full-296ea2677df7d830945942545f0d6b8c.gif";